import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline, Container, AppBar, Toolbar, Typography, Box, Button } from '@mui/material';
import { NotificationProvider } from './contexts/NotificationContext';
import UnifiedOrderForm from './components/forms/UnifiedOrderForm';
import UnifiedOrderHistory from './components/history/UnifiedOrderHistory';
import EmailManagement from './components/email/EmailManagement';
import UnifiedCaseManagement from './components/cases/UnifiedCaseManagement';

// Material-UI theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#2196f3',
    },
    secondary: {
      main: '#ff9800',
    },
  },
});

const NavigationBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          WZF Werkzeugbau - Order Management V3
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            color="inherit"
            onClick={() => navigate('/create')}
            variant={location.pathname === '/create' ? 'outlined' : 'text'}
          >
            Bestellung erstellen {/* Create Order */}
          </Button>
          <Button
            color="inherit"
            onClick={() => navigate('/history')}
            variant={location.pathname === '/history' ? 'outlined' : 'text'}
          >
            Bestellverlauf {/* Order History */}
          </Button>
          <Button
            color="inherit"
            onClick={() => navigate('/emails')}
            variant={location.pathname === '/emails' ? 'outlined' : 'text'}
          >
            E-Mail-Verwaltung {/* Email Management */}
          </Button>
          <Button
            color="inherit"
            onClick={() => navigate('/cases')}
            variant={location.pathname === '/cases' ? 'outlined' : 'text'}
          >
            Case Management {/* Case Management */}
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <NotificationProvider>
        <Router>
          <NavigationBar />
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Routes>
              <Route
                path="/create"
                element={<UnifiedOrderForm />}
              />
              <Route
                path="/history"
                element={<UnifiedOrderHistory />}
              />
              <Route
                path="/emails"
                element={<EmailManagement />}
              />
              <Route
                path="/cases"
                element={<UnifiedCaseManagement />}
              />
              <Route
                path="/"
                element={<Navigate to="/create" replace />}
              />
            </Routes>
          </Container>
        </Router>
      </NotificationProvider>
    </ThemeProvider>
  );
}

export default App;
